import {
  abilities,
  ActionsType,
  DBTablesType,
  parseSubjectResource,
} from "@libs/authorization";
import { UserRoleType } from "@/domain/auth";

export const hasPermission = ({
  userRole,
  userId,
  campusId,
  action,
  subject,
  subjectResource,
}: {
  userRole: UserRoleType | null;
  campusId: string | null;
  userId: string | null;
  action: ActionsType;
  subject: DBTablesType;
  subjectResource?: object;
}) => {
  return abilities({
    userId: userId ?? "",
    userRole,
    campusId,
  }).can(action, parseSubjectResource({ subject, subjectResource }));
};
